import {
  LIST_REPORT3,
  LIST_REPORT3_SUCCESS,
  LIST_REPORT3_CLEAN,
  LIST_REPORT3_ERROR,
} from "./actionTypes"

export const listReport3 = form => ({
  type: LIST_REPORT3,
  payload: { form },
})

export const listReport3Success = report => {
  return {
    type: LIST_REPORT3_SUCCESS,
    payload: { report },
  }
}

export const listReport3Clean = () => {
  return {
    type: LIST_REPORT3_CLEAN,
    payload: {},
  }
}

export const listReport3Error = error => {
  return {
    type: LIST_REPORT3_ERROR,
    payload: error,
  }
}
